<template>
  <div id="home" :style="{'height': (height + 'px')}">
    <spinner :active="spinnerActive"/>
      <div class="content" v-show="animation.content_show">
        <div class="logo">
          <img src="@/assets/icons/rockestate_logo_aligned.svg" alt="" class="logo">
        </div>
        <h1>Building catalog</h1>
        <div class="subtitle">
          Find out building characteristics based on open data
        </div>
        <div class="search-bar">
          <div class="search-button">
            <img src="@/assets/icons/ic-search.svg" alt>
          </div>
          <b-autocomplete
            v-model="search"
            keep-first="true"
            open-on-focus="true"
            :data="filteredDataArray"
            placeholder="Search for address"
            @select="searchSelect"
            @input="handle_adress_input"
          >
            <template slot="empty">
              {{ this.empty_message }}
            </template>
          </b-autocomplete>
        </div>
      <div class="captcha" v-if="show_captcha">
        <vue-recaptcha sitekey="6LcA5r0UAAAAAEakkp_6sL0FwsoCDMKVtFWzaW-_" :loadRecaptchaScript="true" @verify="captcha_callback">
        </vue-recaptcha>
      </div>


      </div>
  </div>
</template>

<script>
import Spinner from "./../components/Spinner";
import axios from "axios";
import VueRecaptcha from 'vue-recaptcha';

// Throttle calls
// https://stackoverflow.com/a/27078401
function throttle(func, wait, options) {
  var context, args, result;
  var timeout = null;
  var previous = 0;
  if (!options) options = {leading: true, trailing: true};
  var later = function() {
    previous = options.leading === false ? 0 : Date.now();
    timeout = null;
    result = func.apply(context, args);
    if (!timeout) context = args = null;
  };
  return function() {
    var now = Date.now();
    if (!previous && options.leading === false) previous = now;
    var remaining = wait - (now - previous);
    context = this;
    args = arguments;
    if (remaining <= 0 || remaining > wait) {
      if (timeout) {
        clearTimeout(timeout);
        timeout = null;
      }
      previous = now;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    } else if (!timeout && options.trailing !== false) {
      timeout = setTimeout(later, remaining);
    }
    return result;
  };
};

export default {
  name: "home",
  components: { Spinner, VueRecaptcha },
  data() {
    return {
      height: 0,
      search: "",
      alert: false,
      searchData: [],
      spinnerActive: false,
      empty_message: "",
      animation: {
        content_show: true
      },
      show_captcha:false,
    };
  },
  computed: {
    filteredDataArray() {
      return this.searchData
    }
  },
  methods: {
    captcha_callback(captcha_token){
      this.$store.state.captcha_token = captcha_token
      this.redirectToHouse()
    },
    searchSelect(val) {
      if (val && val !== "") {
        this.activatereCaptcha();
      }
    },
    activatereCaptcha() {
      this.show_captcha = true;
    },
    redirectToHouse() {
      this.spinnerActive = true;

      this.getSearchData().then(
        data => {
          if ((data.length>0) && data[0].building_id !== "-") {
            this.$store.state.house = data[0];
            setTimeout(() => {
              this.spinnerActive = false;
              this.$router.push({ path: "house?building_id=" + this.$store.state.house.building_id + "&level=" + this.$store.state.house.level +  "&full_address=" + this.$store.state.house.full_address });
            }, 500);
          } else {
            //console.log(data)
          }
        },
        error => {
          //console.log(error);
        }
      );
    },
    handle_adress_input: throttle(function() {
      if (this.search.length < 3) {
        this.searchData = [];
        this.empty_message = "";
        return;
      } else {
        this.empty_message = "No results found";
      }
      // Get results
      this.getSearchData().then(
        data => {
          this.searchData = data.map(data => data.full_address);
          //this.searchData.pop()
        },
        error => {
          //console.log(error);
        }
      );
    }, 250),
    getSearchData() {
      return new Promise((resolve, reject) => {
        axios
          .get(process.env.VUE_APP_API_URL + "/autocomplete", {
            params: {
              term: this.search
            }
          })
          .then(response => {
            resolve(response.data.results);
          });
      });
    }
  },
  created() {
    this.height = window.innerHeight;
    window.addEventListener("resize", () => {
      this.height = window.innerHeight;
    });
    (function() { (function t(loc, tit) { var _a='197401',_b='https://secure.tank3pull.com',_c='';var trk_sw = encodeURIComponent(screen.width).substring(0, 6); var trk_sh = encodeURIComponent(screen.height).substring(0, 6); var trk_ref = encodeURIComponent(document.referrer).substring(0, 1100); var trk_tit = encodeURIComponent(document.title).substring(0, 200); var trk_loc = encodeURIComponent(document.location).substring(0, 1000); var trk_agn = encodeURIComponent(navigator.appName).substring(0, 100); var trk_lng = window.navigator.userLanguage || window.navigator.language; var trk_agv = encodeURIComponent(navigator.userAgent + '.lfcd' + screen.colorDepth + '.lflng' + trk_lng).substring(0, 1000); var trk_dom = encodeURIComponent(document.domain).substring(0, 200); var trk_user = _a; var trk_cookie = ''; var trk_uid = _c; var trk_img = _b + '/Track/Capture.aspx'; var trk_link = trk_img + '?retType=js&trk_uid=' + trk_uid + '&trk_user=' + trk_user + '&trk_sw=' + trk_sw + '&trk_sh=' + trk_sh + '&trk_ref=' + trk_ref + '&trk_tit=' + trk_tit + '&trk_loc=' + trk_loc + '&trk_agn=' + trk_agn + '&trk_agv=' + trk_agv + '&trk_dom=' + trk_dom + '&trk_cookie=NA'; var j = document.createElement('img'); j.src = trk_link; j.style = 'display:none;'; var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(j, s); })();})();
  },
};
</script>
